import { put, call, takeLatest, select, take, delay } from "redux-saga/effects";
import { AsyncReturnType } from "type-fest";

//actions
// import WeatherDataActions from "Containers/WeatherData/WeatherData.actions";
import DatabaseActions from "./Database.actions";

function* onInitiate() {
	yield take((action: any) => action.type === "persist/REHYDRATE" && action.key === "root");
}

function* onUninitiate() {
	console.log("onUninitiate");
}

// function* onFetchWeatherData() {
// 	yield put(WeatherDataActions.SET_IS_LOADING.action(true));
// 	try {
// 		let reachedEndOfList = true;
// 		let offSet = 0;
// 		while (reachedEndOfList) {
// 			const limit = offSet ? 20000 : 1;
// 			const response: AsyncReturnType<typeof fetchWeatherData> = yield call(fetchWeatherData, limit, offSet);
// 			if ("error" in response) throw new Error(response.error);
// 			yield put(WeatherDataActions.ADD_WEATHER_DATA.action(response));
// 			if (response.length === 0) reachedEndOfList = false;
// 			offSet += limit;
// 			// yield delay(30000);

// 			reachedEndOfList = false;
// 		}
// 	} catch (error) {
// 		console.error(error);
// 	}
// 	yield put(WeatherDataActions.SET_IS_LOADING.action(false));
// }

export default function* rootSagas() {
	yield takeLatest(DatabaseActions.INITIATE.ACTION, onInitiate);
	yield takeLatest(DatabaseActions.UNINITIATE.ACTION, onUninitiate);
	// yield takeLatest(WeatherDataActions.FETCH_WEATHER_DATA.REQUEST, onFetchWeatherData);
}
